module.exports = __webpack_public_path__ + "img/231ecec.jpg";